import { Checkbox } from '@cian/ui-kit';
import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { InlineFilter } from 'shared/components/InlineFilter';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectCommissionTypeFilter } from 'shared/selectors/advancedFilters';
import { selectWithoutAgentCall } from 'shared/selectors/jsonQuery';

export const CommissionTypeContainer: FC = () => {
  const { label, value, options } = useSelector(selectCommissionTypeFilter);
  const withoutAgentCall = useSelector(selectWithoutAgentCall);

  const onChange = useFilterChangeCallback();

  const handleCommissionTypeChange = useCallback(
    (newValue: number | null) => {
      onChange({ action: 'setCommissionType', arguments: [newValue] });
    },
    [onChange],
  );

  const handleWithoutAgentCallChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      onChange({ action: 'setWithoutAgentCall', arguments: [checked ? true : null] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <InlineFilterGroup>
        <InlineFilter>
          <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleCommissionTypeChange} />
        </InlineFilter>
        <InlineFilter>
          <Checkbox
            label="Без «Агентам не звонить»"
            checked={withoutAgentCall}
            onChange={handleWithoutAgentCallChange}
          />
        </InlineFilter>
      </InlineFilterGroup>
    </AdvancedFilterRow>
  );
};
